export default __webpack_public_path__ + "static/media/023.4914af15.jpg";